import api from './api';

const API_PREFIX = '/packagedApp';

const getPackagedAppByDeviceIdAll = ({ limit, page, customerEnvId, deviceId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${deviceId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getPackagedApp = ({customerEnvId, globalPackagedAppId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${globalPackagedAppId}`);

const updateGlobalPackagedAppStatus = ({ customerEnvId, globalPackagedAppId, status, notes }) =>
  api.post(`${API_PREFIX}/${customerEnvId}/${globalPackagedAppId}/updateGlobalPackagedAppStatus`, {
    status,
    notes,
  });
const bulkUpdateGlobalPackagedAppStatus = ({ customerEnvId, globalPackagedAppIds, status, notes }) =>
  api.post(`${API_PREFIX}/${customerEnvId}/bulkUpdateGlobalPackagedAppStatus`, {
    globalPackagedAppIds,
    status,
    notes,
  });

const WDACPackagedAppService = {
  updateGlobalPackagedAppStatus,
  bulkUpdateGlobalPackagedAppStatus,
  getPackagedAppByDeviceIdAll,
  getPackagedApp,
};

export default WDACPackagedAppService;
